import { FC, useState } from 'react';
import { getQRCode } from '../../services/orders';
import { displayErrorNotification } from '../../utils/displayNudosStandardNotifications';
import { LoadingOutlined } from '@ant-design/icons';
import { PrintableModal } from './Components';
import LargeQrButton from './Components/LargeQrButton/LargeQrButton';
import SmallQrButton from './Components/SmallQrButton/SmallQrButton';

export enum QRButtonSize {
  SMALL = 'small',
  LARGE = 'large'
}

interface IQRData {
  serial?: string | number | null;
  orgName?: string | null;
  productId?: string | number | null;
}

export interface IQRDownloadButton {
  QRData?: IQRData;
  size?: 'small' | 'large';
  disabled?: boolean;
  isModeDark?: boolean;
}

const QRDownloadButton: FC<IQRDownloadButton> = ({ QRData, size = 'large', disabled = false, isModeDark = false }) => {
  const [qrCode, setQRCode] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);

  const getDataQrCode = async () => {
    setLoading(true);
    try {
      const qrCode = await getQRCode(Number(QRData?.productId));
      setQRCode(qrCode);
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setQRCode(undefined);
  };
  if (!QRData?.productId) return <></>;

  if (loading)
    return (
      <div className="qrDownloadButtonContainer loadingStyles">
        <LoadingOutlined />
      </div>
    );

  return (
    <>
      {qrCode && <PrintableModal qrCode={qrCode} qrData={QRData} closeModal={closeModal} />}
      {size === QRButtonSize.LARGE && (
        <LargeQrButton getQrCodeCallback={getDataQrCode} disabled={disabled} isModeDark={isModeDark} />
      )}
      {size === QRButtonSize.SMALL && <SmallQrButton getQrCodeCallback={getDataQrCode} disabled={disabled} />}
    </>
  );
};

export default QRDownloadButton;
